<div class="container-fluid p-0">
  <div class="heightfull">
    <div class="back_color"></div>
    <div class="logoclass col-md-12 row">
      <img class="logoimg mt-3" src="../../../../assets/images/logoLux.png" />
    </div>
    <div class="contentbox col-md-10 pt-3" *ngIf="isLogin == true">
      <div class="content pt-5">
        <div class="row col-md-12 p-0 m-0">
          <app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>
          <div class="leftimg col-md-6 p-0 align-self-center">
            <img
              class="leftimg"
              src="../../../../assets/images/pngwing.com.png"
            />
          </div>
          <div class="col-md-5 p-0">
            <div class="form_outer">
              <div class="inner_form">
                <div class="formcontent text-center">
                  <span>
                    <p class="log-in">Delete Driver Account</p>
                    <span class="line"></span>
                  </span>
                </div>
                <div class="inputs">
                  <form [formGroup]="loginForm">
                    <div class="form-group mt-3 mb-3">
                      <label>Email</label>
                      <input
                        type="text"
                        formControlName="email"
                        class="form-control login_input"
                        id="exampleInputEmail1"
                        placeholder="Email"
                      />
                      <div
                        *ngIf="
                          loginForm.controls['email'].invalid &&
                          (loginForm.controls['email'].dirty ||
                            loginForm.controls['email'].touched)
                        "
                        class="errorinput text-left"
                      >
                        <div
                          *ngIf="loginForm.controls['email'].errors.required"
                        >
                          *Email is required.
                        </div>
                        <div *ngIf="loginForm.controls['email'].errors.pattern">
                          *Invalid email .
                        </div>
                      </div>
                    </div>

                    <div class="form-group mt-3 mb-3 position-relative">
                      <label>Password</label>
                      <input
                        type="password"
                        formControlName="password"
                        [type]="show ? 'text' : 'password'"
                        class="form-control login_input"
                        id="exampleInputEmail1"
                        placeholder="Password"
                      />
                      <img
                        *ngIf="show == false"
                        (click)="password()"
                        class="show_password"
                        src="../../../../assets/images/visibility.png"
                        alt=""
                      />
                      <img
                        *ngIf="show == true"
                        (click)="password()"
                        class="show_password"
                        src="../../../../assets/images/view.png"
                        alt=""
                      />
                      <div
                        *ngIf="
                          loginForm.controls['password'].invalid &&
                          (loginForm.controls['password'].dirty ||
                            loginForm.controls['password'].touched)
                        "
                        class="errorinput text-left"
                      >
                        <div
                          *ngIf="loginForm.controls['password'].errors.required"
                        >
                          *Password is required.
                        </div>
                        <div
                          *ngIf="
                            loginForm.controls['password'].errors.minlength
                          "
                        >
                          *Minimum password length is 6.
                        </div>
                      </div>
                    </div>

                    <div class="pt-3 pb-3">
                      <button
                        class="btn addCandidateBtn w-100"
                        [disabled]="!loginForm.valid"
                        (click)="login()"
                      >
                        Delete Account
                      </button>
                    </div>
                    <!-- <p class="forgot _add_cursor" (click)="navigateForgot('false')">Forgot Password?</p> -->
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentbox col-md-10 pt-3" *ngIf="isLogin == false">
      <div class="content pt-5">
        <div class="row col-md-12 p-0 m-0">
          <app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>
          <div class="leftimg col-md-6 p-0 align-self-center">
            <img class="leftimg" src="../../../../assets/images/cat-dog2.png" />
          </div>
          <div class="col-md-5 p-0">
            <div class="form_outer">
              <div class="inner_form">
                <div class="formcontent text-center">
                  <p class="log-in">Forgot Password?</p>
                </div>
                <div class="inputs">
                  <form [formGroup]="resetForm">
                    <div class="form-group mt-3 mb-1">
                      <label>Email</label>
                      <input
                        type="text"
                        formControlName="email"
                        class="form-control login_input"
                        id="exampleInputEmail1"
                        placeholder="Email"
                      />
                      <div
                        *ngIf="
                          resetForm.controls['email'].invalid &&
                          (resetForm.controls['email'].dirty ||
                            resetForm.controls['email'].touched)
                        "
                        class="errorinput text-left"
                      >
                        <div
                          *ngIf="resetForm.controls['email'].errors.required"
                        >
                          *Email is required.
                        </div>
                        <div *ngIf="resetForm.controls['email'].errors.pattern">
                          *Invalid email .
                        </div>
                      </div>
                    </div>

                    <div class="pt-3 mb-2">
                      <button
                        class="btn addCandidateBtn w-100"
                        [disabled]="!resetForm.valid"
                        (click)="resetSubmit()"
                      >
                        SUBMIT
                      </button>
                    </div>
                    <p
                      class="forgot _add_cursor"
                      (click)="navigateForgot('true')"
                    >
                      Log In
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
